import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';

export type AppVersionDisplay = {
  label: string | null;
  tooltip: string | null;
};

const APP_VERSION_LOG_SOURCE = 'sm-app-version';
@Component({
  selector: 'sm-app-version',
  templateUrl: './sm-app-version.component.html',
  styleUrls: ['./sm-app-version.component.scss'],
  standalone: false,
})
export class SmAppVersionComponent implements OnInit {
  versionDisplay: AppVersionDisplay = {label: null, tooltip: null};

  ngOnInit(): void {
    this.versionDisplay = this.buildAppVersionDisplay(environment.appVersion);
    this.logVersion(environment.appVersion);
  }

  get versionLabel(): string | null {
    return this.versionDisplay.label;
  }

  get versionTooltip(): string | null {
    return this.versionDisplay.tooltip;
  }

  private buildAppVersionDisplay(appVersion: string | null | undefined): AppVersionDisplay {
    const version = appVersion?.trim() ?? '';

    if (!version) {
      return {label: null, tooltip: null};
    }

    const normalizedVersion = version.replace(/^v/i, '').trim();
    const shortVersion = normalizedVersion.match(/^\d+\.\d+\.\d+/)?.[0] ?? normalizedVersion;

    return {
      label: `v${shortVersion}`,
      tooltip: normalizedVersion,
    };
  }

  private logVersion(appVersion: string | null | undefined): void {
    const version = appVersion?.trim() ?? '';

    if (!version) {
      console.error(`[${APP_VERSION_LOG_SOURCE}] App version is empty.`);
      return;
    }

    console.info(`[${APP_VERSION_LOG_SOURCE}] App version: ${version.replace(/^v/i, '').trim()}`);
  }

}
